import {Form} from "@/utils/Form";
import {UpdateGatewayData} from "@/api";
import {UpdateGatewayMutation, UpdateGatewayMutationVariables, useUpdateGatewayMutation} from "./mutations.generated";
import {DataSource} from "./DataSource";
import deepEqual from "deep-equal";

export default class UpdateGatewayForm extends Form<
    UpdateGatewayMutation,
    UpdateGatewayMutationVariables,
    UpdateGatewayData
> {
    private readonly id: number;
    readonly dataSource: DataSource;

    constructor(id: number, dataSource: DataSource) {
        super("updateGateway");
        this.hooks(useUpdateGatewayMutation, dataSource.gateway);
        this.id = id;
        this.dataSource = dataSource;
    }

    override get hasChanged(): boolean {
        return !deepEqual(this.initialData, this.values);
    }

    protected override get filteredVariables(): UpdateGatewayMutationVariables {
        const values = structuredClone(this.values);

        return {
            id: this.id,
            data: values,
        };
    }
}
